import React from 'react';
import first from './images/1.jpg';
import second from './images/2.jpg';

export default () => (
  <>
    <img src={first} alt="" width="100%" />
    <img src={second} alt="" width="100%" />
  </>
);
